module.exports = __webpack_public_path__ + "static/media/exchange-alt.c1b6511c.svg";